// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'arrow-out';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='M5.625 9.003h11.813m-2.813 2.812 2.813-2.812-2.813-2.813m-2.812 6.185v3.375a1.078 1.078 0 0 1-1.024 1.125H1.585A1.078 1.078 0 0 1 .563 15.75V2.25a1.077 1.077 0 0 1 1.022-1.125h9.204a1.078 1.078 0 0 1 1.024 1.125v3.375'
  />
);

export const viewBox = '0 0 18 18';
